
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUnitById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUnitById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameAr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descriptionAr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unitType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameAr"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"unitDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomNumber"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"oldRent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rentType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floorArea"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfUnits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adultCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"childCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"infantCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPetAllowed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isBachelorAllowed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isFamillyAllowed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentCollectionDay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfRooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfBathrooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfHalls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isParkingAvailable"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":609}};
    doc.loc.source = {"body":"query getUnitById($id: ID) {\n  getUnitById(id: $id) {\n      _id\n      nameEn\n      nameAr\n      descriptionEn\n      descriptionAr\n      rent\n      unitType{\n        _id\n        nameEn\n        nameAr\n      }\n      property{\n        _id\n      }\n      unitDetails{\n        roomNumber\n      }\n      oldRent\n      rentType\n      floorArea\n      numberOfUnits\n      adultCount\n      childCount\n      infantCount\n      isPetAllowed\n      isBachelorAllowed\n      isFamillyAllowed\n      images\n      paymentCollectionDay\n      numberOfRooms\n      numberOfBathrooms\n      numberOfHalls\n      isParkingAvailable\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getUnitById"] = oneQuery(doc, "getUnitById");
        
